// FloatingMenu.jsx
import React from "react";
import styled from "styled-components";
import IconButton from "./Button";

const FloatingMenuContainer = styled.div`
  position: fixed;
  display: flex;
  gap: 16px;
  padding: 8px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 6px 20px 0px rgba(169, 169, 169, 0.25);
  z-index: 9999;

  /* Hide in print if desired */
  ${({ $hideInPrint }) =>
    $hideInPrint &&
    `
    @media print {
      display: none;
    }
  `}

  /* Dynamically position the menu in one of the four corners, with optional offset */
  ${({ $position, offset }) => {
    const topMap = {
      "top-left": `top: ${offset}px; left: ${offset}px;`,
      "top-right": `top: ${offset}px; right: ${offset}px;`,
      "bottom-left": `bottom: ${offset}px; left: ${offset}px;`,
      "bottom-right": `bottom: ${offset}px; right: ${offset}px;`,
      "bottom-center": `bottom: ${offset}px; left: 50%; transform: translateX(-50%);`,
    };
    return topMap[$position] || topMap["bottom-right"];
  }}
`;

const FloatingMenuButton = styled.button`
  border: none;
  background: transparent;
  //   cursor: pointer;
  //   padding: 8px 12px;
  border-radius: 8px;
  font-weight: 500;
  color: #004f96;

  display: flex;
  align-items: center;

  &:hover {
    background: #f2f2f2;
  }
`;

const FloatingMenu = ({
  items = [],
  position = "bottom-right", // "bottom-right", "bottom-left", "top-right", or "top-left"
  offset = 24, // px offset from the corner
  hideInPrint = true, // set false if you want it to appear in printouts
}) => {
  return (
    <FloatingMenuContainer
      $position={position}
      offset={offset}
      $hideInPrint={hideInPrint}
    >
      {items.map((item, i) => (
        <FloatingMenuButton key={i} onClick={item.action}>
          <IconButton variant="ghost" icon={item.icon}>
            {" "}
            {item.label}{" "}
          </IconButton>
        </FloatingMenuButton>
      ))}
    </FloatingMenuContainer>
  );
};

export default FloatingMenu;
